module.exports = __webpack_public_path__ + "img/hiking.f829424f.svg";